module.exports = __webpack_public_path__ + "img/Thumbnails_Serve.6186230e.jpg";